import { Stack } from '@mui/material';
import { Link, NameBanner } from '@rumblefish/ui/Rumblefish23Theme';
import panenkaDashboardImg from '../../../public/webp/fromPNG/portfolio/panenka-dashboard.webp';
import { GlowStack } from '../Faq/styles';
import { panenkaCaseStudyData } from './PanenkaCaseStudy.data';
import {
  StyledButton,
  StyledDashboardImage,
  StyledHeading,
  StyledList,
  StyledParagraph,
  StyledSection,
  StyledTitle,
} from './styles';

export const PanenkaCaseStudy = () => {
  return (
    <StyledSection width="normal">
      <GlowStack />
      <NameBanner type="section" text="Case Study" color="aquamarine" />

      <Stack mt={8}>
        <StyledTitle variant="display_sm">
          {panenkaCaseStudyData.title}
        </StyledTitle>

        <Stack
          direction={{ xs: 'column-reverse', md: 'row' }}
          gap={6}
          alignItems="flex-start"
          width="100%">
          <Stack sx={{ width: '100%' }}>
            <StyledHeading variant="strong_500">
              {panenkaCaseStudyData.challenge.title}
            </StyledHeading>

            <StyledParagraph variant="regular_400">
              {panenkaCaseStudyData.challenge.description}
              <StyledList>
                {panenkaCaseStudyData.challenge.items.map((point, index) => (
                  <li key={index}>
                    <StyledParagraph variant="regular_400">
                      {point}
                    </StyledParagraph>
                  </li>
                ))}
              </StyledList>
            </StyledParagraph>

            <StyledHeading variant="strong_500" sx={{ mt: 2 }}>
              {panenkaCaseStudyData.whyStandardToolsFailed.title}
            </StyledHeading>

            <StyledParagraph variant="regular_400">
              <StyledList>
                {panenkaCaseStudyData.whyStandardToolsFailed.items.map(
                  (point, index) => (
                    <li key={index}>
                      <StyledParagraph variant="regular_400">
                        {point}
                      </StyledParagraph>
                    </li>
                  )
                )}
              </StyledList>
            </StyledParagraph>
          </Stack>

          <Stack
            sx={{
              width: {
                xs: '100%',
                md: '750px',
                lg: '850px',
                xl: '1000px',
              },
            }}>
            <StyledDashboardImage
              src={panenkaDashboardImg}
              alt="Panenka Dashboard"
            />
          </Stack>
        </Stack>

        <StyledHeading variant="regular_400" sx={{ mt: 2 }}>
          {panenkaCaseStudyData.approach}
        </StyledHeading>

        <Stack
          sx={{
            width: '100%',
            justifyContent: 'center',
            alignItems: 'center',
          }}>
          <Link to="/case-studies/panenka" sx={{ mt: 4 }}>
            <StyledButton>Read the full case study</StyledButton>
          </Link>
        </Stack>
      </Stack>
    </StyledSection>
  );
};
